<script setup>
import BankInformations from '@/components/admin/bank-informations/BankInformations.vue';
import CreateLink from '@/components/admin/create-link/CreateLink.vue';
import BulkOperations from '@/components/admin/bulk-operations/BulkOperations.vue';
import {
  defineComponent, onMounted, reactive, watch, ref,
} from 'vue';
import useAdminStore from '@/store';
import Animation from '@/components/dashboard/common/Animation.vue';

defineComponent({
  name: 'AsyncAdmin',
});

const admin = useAdminStore();

const bankInfo = reactive({ active: false });
const banks = reactive({ internetBanking: [], swift: [], cryptoCurrency: [] });
const loading = reactive({ isLoading: true });
const showBulkOperations = ref(false);

await onMounted(async () => {
  await admin.getBanks();
  bankInfo.active = admin.getAnyBankAdded;
  banks.internetBanking = admin.getInternetBanking;
  banks.swift = admin.getSwift;
  banks.cryptoCurrency = admin.getCryptoCurrency;
  loading.isLoading = false;
});

watch(() => admin.getInternetBanking, () => {
  banks.internetBanking = admin.getInternetBanking;
});
watch(() => admin.getSwift, () => {
  banks.swift = admin.getSwift;
});
watch(() => admin.getCryptoCurrency, () => {
  banks.cryptoCurrency = admin.getCryptoCurrency;
});

function toggleBulkOperations() {
  showBulkOperations.value = !showBulkOperations.value;
}

</script>

<template>
  <div v-if="!loading.isLoading" class="h-full">
    <!-- Bulk Operations Toggle Button -->
    <div class="mb-4 flex justify-end">
      <button
        @click="toggleBulkOperations"
        class="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors
               flex items-center gap-2"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1
               4l-3 3m0 0l-3-3m3 3V4"

          ></path>
        </svg>
        {{ showBulkOperations ? 'Hide Bulk Operations' : 'Show Bulk Operations' }}
      </button>
    </div>

    <!-- Bulk Operations Component (conditionally shown) -->
    <div v-if="showBulkOperations" class="mb-6">
      <BulkOperations />
    </div>

    <CreateLink v-if="bankInfo.active"/>
    <BankInformations :internet-banking="banks.internetBanking"
                      :swift='banks.swift'
                      :crypto-currency="banks.cryptoCurrency"/>
  </div>
  <div v-else class="grid grid-cols-3">
    <div v-for="n in 12" class="m-4" :key="n">
      <Animation/>
    </div>
  </div>
</template>
